import { render, staticRenderFns } from "./belongInfo.vue?vue&type=template&id=600d7fee&scoped=true&"
import script from "./belongInfo.vue?vue&type=script&lang=js&"
export * from "./belongInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d7fee",
  null
  
)

export default component.exports